import { ORDER_METHODS, RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'In sede',
      [RoomServiceLocationType.TableService]: 'In sede',
      both: 'In sede',
    },
    [ORDER_METHODS.PICKUP]: 'Ritiro',
    [ORDER_METHODS.DELIVERY]: 'Consegna',
  },
};
